import axios from 'axios';
import React, { useContext, useEffect, useState } from 'react'
import { Formik , Form , ErrorMessage, Field } from 'formik';
import toast from 'react-hot-toast';
import cover from "../../Assets/images/4.jpeg"

import "./sickHistory.css";
import { UserContext } from '../../Context/UserContext.js';
import CustomTitle from '../CustomTitle/CustomTitle.jsx';




export default function SickHistory() {
   const [showHistory, setShowHistory] = useState("showHistory");
   const [history, setHistory] = useState({});
   const [selectedFile, setSelectedFile] = useState(null);
   const [error, setError] = useState(null);
   const [isLoadingAdded, setIsLoadingAdded] = useState(false);
   const {userToken} = useContext(UserContext) ;


   const token = `${process.env.REACT_APP_BEARER_TOKEN} ${userToken || localStorage.getItem("token")}` ;



   async function submitData(files , values){
      setIsLoadingAdded(true)
      const formData = new FormData()
      let headers ={ 'enctype' :'multipart/form-data' , token} ;
      
      formData.append('history_disease', values.history_disease);
      formData.append('history_medicines', values.history_medicines);
      formData.append('history_surgeries', values.history_surgeries);

      // Append multiple files
      if (files && files.length > 0) {
         Array.from(files).forEach((file) => {
            formData.append('files', file); // Backend لازم يدعم `files[]` أو `files`
         });
      }

      await axios.post(`${process.env.REACT_APP_BASE_URL}/api/v1/history` , formData , {headers} )
      .then(({data})=>{
         if(data?.message === "success"){
            setIsLoadingAdded(false)
            toast.success("Successfully Updated");
            window.location.reload() ;
         }
      })
      .catch((error)=>{
         setIsLoadingAdded(false)
         toast.error(error.response?.data?.message)
         setError(error.response?.data?.message)
      })
   }

   async function getData(){
      await axios.get(`${process.env.REACT_APP_BASE_URL}/api/v1/history/historyLoggedUser`, {headers:{token}} )
      .then(({data})=>{
         setIsLoadingAdded(false)
         setHistory(data.history)
      })
      .catch((error)=>{
         setIsLoadingAdded(false)
         toast.error(error.response?.data?.message)
         setError(error.response?.data?.message)
      })
   }

   const validateForm = (values) => {
      const errors = {};
      if (!values.history_disease) errors.history_disease = 'Input Disease is required';
      if (!values.history_medicines) errors.history_medicines = 'Input Medicines is required';
      if (!values.history_surgeries) errors.history_surgeries = 'Input Surgeries is required';
      if (!values.files || values.files.length === 0) errors.files = 'Input images are required';
      return errors;
   };

   useEffect(() => {
      getData()
   }, [])

   return (
      <div>
         <CustomTitle title="التاريخ المرضى" />

         {showHistory === "showHistory"? 
            <div className='container my-4 bg-body-tertiary rounded-2 p-1'>
               <div className='text-center my-2 px-2'>
                  <button onClick={()=>{setShowHistory("updateHistory")}} className='btn btn-sm bg-main'>تعديل ملفى الطبى</button>
               </div>

               <div>
                  <h1 className='main-header'>عرض ملفى الطبى</h1>

                  <div  className='text-center bg-body-secondary rounded-2 mx-1 my-2 p-1'>
                     <h5>الامراض المزمنة</h5>
                     <p>{history.history_disease}</p>
                  </div>


                  <div  className='text-center bg-body-secondary rounded-2 mx-1 my-2 p-1'>
                     <h5>الادوية مزمنة </h5>
                     <p>{history.history_medicines}</p>
                  </div>


                  <div  className='text-center bg-body-secondary rounded-2 mx-1 my-2 p-1'>
                     <h5>العمليات الجراحية السابقة</h5>
                     <p>{history.history_surgeries}</p>
                  </div>

                  <div className='row g-2 my-4 text-center'>
                     <h5>التقارير السابقة</h5>
                     {history?.images?.map((ele)=>
                        <div key={ele._id} className="col-6 "><div className='p-2'><img src={ele} className='w-100 rounded-2 overflow-hidden' alt={ele} /></div></div>
                     )}
                  </div>
               </div>
            </div>
         :""}




         {showHistory === "updateHistory" ? 
            <div className='my-4'>
               <div className='text-center my-2  px-3'>
                  <button onClick={()=>{setShowHistory("showHistory")}} className='btn btn-sm bg-main'>عرض ملفى الطبى</button>
               </div>

               <div className="row">
                  <div className="col-md-8 offset-md-2">
                     <Formik
                           initialValues={{
                              files: null ,
                              history_surgeries: history?.history_surgeries || "",
                              history_medicines: history?.history_medicines || "",
                              history_disease: history?.history_disease || "",
                           }} 
                           enableReinitialize={true}
                           validate={validateForm}
                           onSubmit={(values) => {submitData(selectedFile , values)}}>
                           {({ isSubmitting, setFieldValue }) => (
                              
                              <Form className='container SickHistory-container'>
                                 <h1 className='main-header'>تعديل ملفى الطبى</h1>


                                 <div className=" mt-3 p-2 position-relative">
                                    <label htmlFor="history_disease" className="form-label text-center">هل لديك أمراض مزمنة ؟</label>
                                    <Field 
                                       as="textarea"
                                       className="form-control"
                                       name="history_disease"
                                       id="history_disease"
                                       rows="4" 
                                       dir="rtl"
                                       placeholder="اكتب هنا الامراض التى تعانى منها مثل : مرض السكرى - مرض ضغط الدم"
                                    />
                                    <ErrorMessage name="history_disease" component="div" className="text-danger" />
                                 </div>


                                 <div className=" mt-3  p-2 position-relative">
                                    <label htmlFor="history_medicines" className="form-label text-center">هل تتناول ادوية مزمنة ؟</label>
                                    <Field 
                                       as="textarea"
                                       className="form-control"
                                       name="history_medicines"
                                       id="history_medicines"
                                       rows="4" 
                                       dir="rtl"
                                       placeholder="اكتب اسماء الادوية التى تتناولها"
                                    />
                                    <ErrorMessage name="history_medicines" component="div" className="text-danger" />
                                 </div>


                                 <div className=" mt-3 p-2 position-relative">
                                    <label htmlFor="history_surgeries" className="form-label text-center">هل أجريت عمليات جراحية من قبل؟</label>
                                    <Field 
                                       as="textarea"
                                       className="form-control"
                                       name="history_surgeries"
                                       id="history_surgeries"
                                       rows="4" 
                                       dir="rtl"
                                       placeholder="اكتب اسم العملية الجراحية التى اجريتها"
                                    />
                                    <ErrorMessage name="history_surgeries" component="div" className="text-danger" />
                                 </div>


                                 <div className='mt-4 p-1 position-relative'>
                                       <label htmlFor="image" className="form-label">إرفاق التقارير السابقة</label>
                                       <input type="file" multiple className="text-danger form-control" onChange={(event) => {setSelectedFile(event.target.files);setFieldValue('files', event.target.files);}}/>
                                       <ErrorMessage name="files" component="div" className="text-danger" />
                                 </div>

                                 <div className='d-flex justify-content-center mt-4 '>
                                    {isLoadingAdded? <>

                                       <button type=" button"  className="btn bg-main w-75">
                                          <i className='fas fa-spinner fa-spin fs-4'/>
                                       </button>

                                    </> : <>
                                       <button type="submit" disabled={isSubmitting} className="btn bg-main w-75">إرسال البيانات</button>
                                    </>}
                                 </div>

                              </Form>
                           )}
                     </Formik>
                  </div>
               </div>
            </div>
         :""}
      </div>
   );
}
